import React from "react";

import { faChartPieSimple, faUsers } from "@fortawesome/pro-regular-svg-icons";
import { faUserTie } from "@fortawesome/pro-solid-svg-icons";

import { Skeleton } from "@performyard/py-components";

import StatCard from "./StatCard";

import { useAdminSettingsHomeSeatUsage } from "../../../../api/hooks";

type Props = {
	companyId?: string;
};

const SeatStatCards: React.FC<Props> = ({ companyId }) => {
	const { data, isLoading } = useAdminSettingsHomeSeatUsage(companyId);

	if (isLoading || !data) {
		return (
			<div className="flex gap-4">
				<Skeleton className="h-[136px] flex-1" />
				<Skeleton className="h-[136px] flex-1" />
				<Skeleton className="h-[136px] flex-1" />
			</div>
		);
	}

	return (
		<div className="flex gap-4">
			<StatCard value={data.active} label="Active Seats" icon={faUserTie} color="blue" />
			{data.max > 0 ? (
				<>
					<StatCard value={data.max} label="Total Available Seats" icon={faUsers} color="green" />
					<StatCard value={data.remaining} label="Remaining Seats" icon={faChartPieSimple} color="orange" />
				</>
			) : null}
		</div>
	);
};

export default SeatStatCards;
